import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import React from "react";
import { getAllEvents } from "../../../services/event.service";
import { getUserOnly } from "../../../services/expositor/subscriptions.service";
import { deleteSubscription } from "../../../services/subscriptions.service";
import { useConfirm } from "../../../ui-components/ConfirmProvider";
import { ModalComponent, useModal } from "../../../ui-components/Modal";
import SectionTitle from "../../../ui-components/SectionTitle";
import { useToast } from "../../../ui-components/ToastProvider";
import { parseDateLocale } from "../../../utils/parseDate";
import UpdateSubscriptionForm from "./UpdateSubscriptionForm.jsx";

const space = {
  shared: "Compartilhado",
  exclusive: "Exclusivo",
  "1_tendas": "1 Tenda",
  "2_tendas": "2 Tendas",
  autoral: "Marcas Autorais",
  alimentacao: "Praça de Alimentação",
};

export default function PreSubscriptions() {
  const { showToast } = useToast();
  const { confirm } = useConfirm();
  const [userSubscriptions, setUserSubscriptions] = React.useState([]);
  const [selectedSub, setSelectedSub] = React.useState({});
  const [events, setEvents] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const { open, handleOpen, handleClose } = useModal();

  function syncEvents() {
    getAllEvents().then((eventsArr) => {
      setEvents(eventsArr);
    });
  }

  React.useEffect(() => {
    syncEvents();
  }, []);

  async function syncSubscriptions() {
    setLoading(true);
    setUserSubscriptions(await getUserOnly());
    setLoading(false);
  }

  React.useEffect(() => {
    syncSubscriptions();
  }, []);

  React.useEffect(() => {
    console.log(userSubscriptions);
  }, [userSubscriptions]);

  const PreSubCard = ({ sub }: any) => {
    const spaceLabels: any = {
      shared: "Compartilhado",
      exclusive: "Exclusivo",
      "1_tendas": "1 Tenda",
      "2_tendas": "2 Tendas",
      autoral: "Marcas Autorais",
      alimentacao: "Praça de Alimentação",
    };

    const mesa = Boolean(sub.extra_table);
    const cadeira = Boolean(sub.extra_chair);
    const mesaQtd = mesa ? sub.table_quantity || 0 : 0;
    const cadeiraQtd = cadeira ? sub.chair_quantity || 0 : 0;
    return (
      <Paper
        sx={{
          borderLeft: "6px solid #f59e0b",
          p: { xs: 2, sm: 2.5 },
          borderRadius: 2,
          border: "1px solid #e2e8f0",
          boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
          transition: "box-shadow 0.2s ease, transform 0.2s ease",
          "&:hover": {
            boxShadow: "0 6px 14px rgba(0,0,0,0.08)",
            transform: "translateY(-1px)",
          },
        }}
      >
        <Grid
          container
          spacing={2}
          alignItems="flex-start"
          justifyContent="space-between"
        >
          <Grid item xs={12} sm={8}>
            <Typography variant="h6" sx={{ fontWeight: 700, color: "#24324D" }}>
              Evento:{" "}
              {events.find((e: any) => e.id === sub.event_id)?.name ||
                sub.name ||
                "Evento não encontrado"}
            </Typography>
            <Box sx={{ display: "flex", gap: 1, mt: 1, flexWrap: "wrap" }}>
              <Chip
                label="Em avaliação"
                color="warning"
                variant="outlined"
                sx={{ fontWeight: 600 }}
              />
              <Chip
                label={`Espaço: ${
                  spaceLabels[sub.space_type] || sub.space_type
                }`}
                variant="outlined"
              />
              <Chip
                label={
                  mesa ? `Mesa extra: Sim (${mesaQtd})` : "Mesa extra: Não"
                }
                color={mesa ? "success" : "default"}
                variant="outlined"
              />
              <Chip
                label={
                  cadeira
                    ? `Cadeira extra: Sim (${cadeiraQtd})`
                    : "Cadeira extra: Não"
                }
                color={cadeira ? "success" : "default"}
                variant="outlined"
              />
              <Chip label={`Valor: R$ ${sub.amount},00`} variant="outlined" />
            </Box>
            <Box sx={{ mt: 2 }}>
              <Typography>
                <span style={{ color: "#24324D", fontWeight: 600 }}>
                  Data de início:{" "}
                </span>
                {parseDateLocale(sub.start_date)}
              </Typography>
              <Typography>
                <span style={{ color: "#24324D", fontWeight: 600 }}>
                  Data de fim:{" "}
                </span>
                {parseDateLocale(sub.end_date)}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Box
              sx={{
                background: "#f8fafc",
                border: "1px solid #e2e8f0",
                borderRadius: 2,
                p: 2,
              }}
            >
              <Typography sx={{ color: "#24324D", fontWeight: 600, mb: 1 }}>
                Itens
              </Typography>
              <Typography sx={{ color: "#475569" }}>{sub.items}</Typography>
              <Typography
                sx={{ color: "#24324D", fontWeight: 600, mt: 2, mb: 1 }}
              >
                Observação
              </Typography>
              <Typography sx={{ color: "#475569" }}>{sub.notes}</Typography>
              <Typography
                sx={{
                  fontSize: "0.875rem",
                  mt: 2,
                  background: "#f1f5f9",
                  border: "1px solid #e2e8f0",
                  borderRadius: "9999px",
                  textAlign: "center",
                  color: "#64748b",
                  px: 2,
                  py: 0.5,
                }}
              >
                Última atualização: {parseDateLocale(sub.updated_at)}
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Grid
          sx={{
            mt: 2,
            display: "flex",
            gap: "10px",
            flexWrap: "wrap",
          }}
        >
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#24324D",
              color: "#ffffff",
              fontWeight: 600,
              borderRadius: 2,
              px: 2.5,
              py: 1,
              textTransform: "none",
              boxShadow: "0 2px 8px rgba(36,50,77,0.25)",
              "&:hover": {
                backgroundColor: "#1a2538",
                transform: "translateY(-1px)",
                boxShadow: "0 6px 14px rgba(36,50,77,0.35)",
              },
              transition: "all 0.2s ease-in-out",
            }}
            onClick={() => {
              setSelectedSub(sub);
              handleOpen();
            }}
          >
            Alterar Informações
          </Button>
          <Button
            onClick={async () => {
              const ok = await confirm({
                title: "Cancelar inscrição",
                description:
                  "Você realmente deseja cancelar esta inscrição? Essa operação é irreversível!",
                confirmText: "Cancelar",
                cancelText: "Voltar",
              });
              if (!ok) return;
              deleteSubscription(sub.id).then(() => {
                showToast("Inscrição apagada com sucesso!", {
                  severity: "success",
                });
                window.location.reload();
              });
            }}
            variant="outlined"
            sx={{
              color: "#24324D",
              borderColor: "#24324D",
              fontWeight: 600,
              borderRadius: 2,
              px: 2.5,
              py: 1,
              textTransform: "none",
              "&:hover": {
                borderColor: "#1a2538",
                color: "#1a2538",
              },
            }}
          >
            Cancelar Inscrição
          </Button>
        </Grid>
      </Paper>
    );
  };

  return (
    <>
      <ModalComponent
        open={open}
        handleClose={handleClose}
        title="Editando pré-inscrição para evento:"
        maxWidth={900}
        autoHeight
      >
        <UpdateSubscriptionForm
          handleClose={handleClose}
          selectedSub={selectedSub}
          events={events}
        />
      </ModalComponent>
      <Grid container>
        <Paper
          sx={{
            p: { xs: 2, sm: 3 },
            width: "100%",
            borderRadius: 3,
            border: "1px solid #e2e8f0",
            boxShadow:
              "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
          }}
        >
          <SectionTitle title={"Pré inscrições em avaliação:"} />
          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
              <CircularProgress />
            </Box>
          ) : (
            userSubscriptions &&
            userSubscriptions
              .filter((x) => x.status_id === 0)
              .map((sub) => (
                <Grid pb="10px" key={sub.id}>
                  <Grid>
                    <PreSubCard sub={sub} />
                  </Grid>
                </Grid>
              ))
          )}
        </Paper>
      </Grid>
    </>
  );
}
